import { useEffect } from "react";
import {
  AppBox,
  AppIconButton,
  AppPaper,
  AppSkeletonAwardList,
  AppSkeletonStatistics,
  AppTitle,
} from "../../../../commons/components";
import { useAppDispatch, useAppSelector } from "../../../../hooks/app";
import { StatusEnum } from "../../../../commons/enums/status-enum";
import { useNavigate } from "react-router";
import PlayerStatisticsCard from "../../../public/player-detail/components/PlayerStatisticsCard";
import { fetchManagePlayerBasicStatistics } from "../../../../redux/slices/football/admin/player/manage-player-basic-statistics-slice";
import IconSquareCornerArrow from "../../../../commons/components/icons/square-corner-arrow";
import { Tooltip } from "react-tooltip";

const PlayerStatistics = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { playerInfo, playerInfoStatus } = useAppSelector((state) => state.footballManagePlayer);
  const { playerStatistics, playerStatisticsStatus } = useAppSelector((state) => state.footballManagePlayerStatistics);
  const { theme } = useAppSelector((state) => state.session);

  useEffect(() => {
    if (playerInfo.id) {
      dispatch(
        fetchManagePlayerBasicStatistics({
          playerId: playerInfo.id,
        })
      );
    }
  }, [playerInfo]);

  const handleStatsBtnClick = (e: any) => {
    e.stopPropagation();
    if (playerInfo?.id) {
      navigate(`/manage/players/${playerInfo.id}/statistics`);
    }
  };

  return (
    <AppBox flexDirection="column" gap="xs" className="w-100">
      <AppTitle as="h5">My Statistics</AppTitle>
      {playerInfoStatus === StatusEnum.Loading ? (
        <AppSkeletonAwardList numberOfItems={1} />
      ) : (
        <AppPaper padding="xs" shadow="xs">
          <AppBox className="w-100" flexDirection="column" gap="xs">
            {playerStatisticsStatus === StatusEnum.Loading ? (
              <AppSkeletonStatistics noTitle />
            ) : (
              <AppBox flexDirection="column" alignItems="center" gap="xs" style={{ position: "relative" }}>
                <PlayerStatisticsCard player={playerInfo} playerStats={playerStatistics} withoutPadding withoutShadow />
                <span style={{ position: "absolute", right: "0.5rem" }} data-tooltip-id="player-stats-btn">
                  <AppIconButton icon={<IconSquareCornerArrow />} variant="subtle" onClick={handleStatsBtnClick} />
                </span>
                <Tooltip
                  id="player-stats-btn"
                  content={"View Detail Statistics"}
                  place="left"
                  variant={theme === "dark" ? "light" : "dark"}
                />
              </AppBox>
            )}
          </AppBox>
        </AppPaper>
      )}
    </AppBox>
  );
};

export default PlayerStatistics;
